/*****************************************************************************
 * NOTICE appModuleRoutes will auto generate when run register module script.
 * PLEASE DO NOT change it manually
 *****************************************************************************
 */

// APP_MODULE_ROUTES
const appModuleRoutes = [
  // {
  //   path: "administrator",
  //   loadChildren:
  //     "./modules/administrator/administrator.module#AdministratorModule",
  // },
  // {
  //   path: "category",
  //   loadChildren: "./modules/category/category.module#CategoryModule",
  // },
  // {
  //   path: "explore",
  //   loadChildren: "./modules/explore/explore.module#ExploreModule",
  // },
  // {
  //   path: "home",
  //   loadChildren: "./modules/home/homepage.module#HomepageModule",
  // },
  // {
  //   path: "notification",
  //   loadChildren:
  //     "./modules/notification/notification.module#NotificationModule",
  // },
  // {
  //   path: "photo",
  //   loadChildren: "./modules/photo/photo.module#PhotoModule",
  // },
  // {
  //   path: "search",
  //   loadChildren: "./modules/search/search.module#SearchModule",
  // },
  // {
  //   path: "upload",
  //   loadChildren: "./modules/upload/upload.module#UploadModule",
  // },
  {
    path: "user",
    loadChildren: "./modules/user/user.module#UserModule",
  },
  // {
  //   path: "preset",
  //   loadChildren: "./modules/preset/preset.module#PresetModule",
  // },
];
// END_APP_MODULE_ROUTES

import { NgModule } from "@angular/core";
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from "@angular/router";
import { ErrorPageComponent } from "./core/modules/home/components/error-page/error-page.component";
import { FileDetailComponent } from "./modules/digital-memory-log/components/file-detail/file-detail.component";
import { PreviewComponent } from "./modules/digital-memory-log/components/preview/preview.component";
import { PreviewSubscriptionComponent } from "./modules/digital-memory-log/components/preview/preview-subscription/preview-subscription.component";
import { PreviewStripeCheckoutComponent } from "./modules/digital-memory-log/components/preview/preview-stripe-checkout/preview-stripe-checkout.component";
import { PreviewAccessComponent } from "./modules/digital-memory-log/components/preview/preview-access/preview-access.component";
import { ShipGalleryComponent } from "./modules/digital-memory-log/components/ships-gallery/ships-gallery.component";
import { DigitalLayoutComponent } from "./shared/layouts/digital-layout/digital-layout.component";
import { CamerallaAuthGuardService } from "./shared/services/guard-services/cameralla-auth-guard.service";
import { PersmissionGuardService } from "./shared/services/guard-services/persmission-guard.service";

// Custom matcher for ship-{name}-{id} format
export function shipMatcher(url: UrlSegment[]): UrlMatchResult {
  console.log('shipMatcher called with url:', url);
  
  if (url.length >= 1 && url[0].path.startsWith('ship-') && url[0].path.includes('-')) {
    const fullPath = url[0].path;
    const parts = fullPath.split('-');
    
    console.log('Ship URL parts:', parts);
    
    // Should have at least 3 parts: 'ship', name parts, and id
    if (parts.length >= 3 && parts[0] === 'ship') {
      const lastPart = parts[parts.length - 1];
      
      // Check if last part is a number (shipId)
      if (/^\d+$/.test(lastPart)) {
        const shipId = lastPart;
        const shipName = parts.slice(1, -1).join('-'); // Everything between 'ship-' and '-{id}'
        
        console.log('Ship matcher success - shipId:', shipId, 'shipName:', shipName);
        
        return {
          consumed: [url[0]], // Only consume the first segment
          posParams: {
            shipId: new UrlSegment(shipId, {}),
            shipName: new UrlSegment(shipName, {})
          }
        };
      }
    }
  }
  
  console.log('Ship matcher failed');
  return null;
}

// Custom matcher for preview-{name}-{id}/file-detail-{name}-{id} format
export function previewFileDetailGlobalMatcher(url: UrlSegment[]): UrlMatchResult {
  console.log('previewFileDetailGlobalMatcher called with url:', url);
  
  if (url.length === 2 && 
      url[0].path.startsWith('preview-') && 
      url[1].path.startsWith('file-detail-')) {
    
    // Parse preview segment
    const previewPath = url[0].path;
    const previewParts = previewPath.split('-');
    
    // Parse file-detail segment  
    const fileDetailPath = url[1].path;
    const fileDetailParts = fileDetailPath.split('-');
    
    console.log('Global Preview parts:', previewParts, 'File detail parts:', fileDetailParts);
    
    // Validate preview format: preview-{name}-{id}
    if (previewParts.length >= 3 && previewParts[0] === 'preview') {
      const previewLastPart = previewParts[previewParts.length - 1];
      
      // Validate file-detail format: file-detail-{name}-{id}
      if (fileDetailParts.length >= 3 && 
          fileDetailParts[0] === 'file' && 
          fileDetailParts[1] === 'detail') {
        
        const fileDetailLastPart = fileDetailParts[fileDetailParts.length - 1];
        
        // Both last parts should be numbers
        if (/^\d+$/.test(previewLastPart) && /^\d+$/.test(fileDetailLastPart)) {
          const previewId = previewLastPart;
          const previewName = previewParts.slice(1, -1).join('-');
          const subSectionId = fileDetailLastPart;
          const subSectionName = fileDetailParts.slice(2, -1).join('-');
          
          console.log('Global preview file detail matcher success:', {
            previewId, previewName, subSectionId, subSectionName
          });
          
          return {
            consumed: url,
            posParams: {
              previewId: new UrlSegment(previewId, {}),
              previewName: new UrlSegment(previewName, {}),
              subSectionId: new UrlSegment(subSectionId, {}),
              subSectionName: new UrlSegment(subSectionName, {})
            }
          };
        }
      }
    }
  }
  
  console.log('Global preview file detail matcher failed');
  return null;
}

// Custom matcher for preview-{name}-{id} format (single segment)
export function previewGlobalMatcher(url: UrlSegment[]): UrlMatchResult {
  console.log('previewGlobalMatcher called with url:', url);
  
  if (url.length === 1 && url[0].path.startsWith('preview-') && url[0].path.includes('-')) {
    const fullPath = url[0].path;
    const parts = fullPath.split('-');
    
    console.log('Global Preview URL parts:', parts);
    
    // Should have at least 3 parts: 'preview', name parts, and id
    if (parts.length >= 3 && parts[0] === 'preview') {
      const lastPart = parts[parts.length - 1];
      
      // Check if last part is a number (previewId)
      if (/^\d+$/.test(lastPart)) {
        const previewId = lastPart;
        const previewName = parts.slice(1, -1).join('-'); // Everything between 'preview-' and '-{id}'
        
        console.log('Global preview matcher success - previewId:', previewId, 'previewName:', previewName);
        
        return {
          consumed: url,
          posParams: {
            previewId: new UrlSegment(previewId, {}),
            previewName: new UrlSegment(previewName, {})
          }
        };
      }
    }
  }
  
  console.log('Global preview matcher failed');
  return null;
}

// Custom matcher for preview-{name}-{id}/access format (paid access OTP gate)
export function previewAccessGlobalMatcher(url: UrlSegment[]): UrlMatchResult {
  if (url.length === 2 && url[0].path.startsWith("preview-") && url[1].path === "access") {
    const previewPath = url[0].path;
    const previewParts = previewPath.split("-");

    if (previewParts.length >= 3 && previewParts[0] === "preview") {
      const previewLastPart = previewParts[previewParts.length - 1];

      if (/^\d+$/.test(previewLastPart)) {
        const previewId = previewLastPart;
        const previewName = previewParts.slice(1, -1).join("-");

        return {
          consumed: url,
          posParams: {
            previewId: new UrlSegment(previewId, {}),
            previewName: new UrlSegment(previewName, {}),
          },
        };
      }
    }
  }

  return null;
}

// Custom matcher for preview-{name}-{id}/subscription format
export function previewSubscriptionGlobalMatcher(url: UrlSegment[]): UrlMatchResult {
  if (
    url.length === 2 &&
    url[0].path.startsWith("preview-") &&
    url[1].path === "subscription"
  ) {
    const previewPath = url[0].path;
    const previewParts = previewPath.split("-");

    if (previewParts.length >= 3 && previewParts[0] === "preview") {
      const previewLastPart = previewParts[previewParts.length - 1];

      if (/^\d+$/.test(previewLastPart)) {
        const previewId = previewLastPart;
        const previewName = previewParts.slice(1, -1).join("-");

        return {
          consumed: url,
          posParams: {
            previewId: new UrlSegment(previewId, {}),
            previewName: new UrlSegment(previewName, {}),
          },
        };
      }
    }
  }

  return null;
}

// Custom matcher for preview-{name}-{id}/subscription/checkout format
export function previewStripeCheckoutGlobalMatcher(url: UrlSegment[]): UrlMatchResult {
  if (
    url.length === 3 &&
    url[0].path.startsWith("preview-") &&
    url[1].path === "subscription" &&
    url[2].path === "checkout"
  ) {
    const previewPath = url[0].path;
    const previewParts = previewPath.split("-");

    if (previewParts.length >= 3 && previewParts[0] === "preview") {
      const previewLastPart = previewParts[previewParts.length - 1];

      if (/^\d+$/.test(previewLastPart)) {
        const previewId = previewLastPart;
        const previewName = previewParts.slice(1, -1).join("-");

        return {
          consumed: url,
          posParams: {
            previewId: new UrlSegment(previewId, {}),
            previewName: new UrlSegment(previewName, {}),
          },
        };
      }
    }
  }

  return null;
}

const routes: Routes = [
  // {
  //   path: "",
  //   component: PublicLayoutComponent,
  //   children: [
  //     {
  //       path: "",
  //       component: LadipageComponent,
  //     },
  //   ]
  // },
   {
    path: "",
    loadChildren: "./modules/auth/auth.module#AuthModule",
  },
   {
    path: "auth",
    loadChildren: "./modules/auth/auth.module#AuthModule",
  },
  // Global matcher for preview-{name}-{id}/file-detail-{name}-{id} format
  {
    matcher: previewFileDetailGlobalMatcher,
    component: FileDetailComponent,
  },
  // Global matcher for preview-{name}-{id}/access format
  {
    matcher: previewAccessGlobalMatcher,
    component: PreviewAccessComponent,
  },
  // Global matcher for preview-{name}-{id}/subscription format
  {
    matcher: previewSubscriptionGlobalMatcher,
    component: PreviewSubscriptionComponent,
  },
  // Global matcher for preview-{name}-{id}/subscription/checkout format
  {
    matcher: previewStripeCheckoutGlobalMatcher,
    component: PreviewStripeCheckoutComponent,
  },
  // Global matcher for preview-{name}-{id} format
  {
    matcher: previewGlobalMatcher,
    component: PreviewComponent,
  },
  {
    path: "preview/:previewId",
    component: PreviewComponent,
  },
  {
    path: "preview/:previewId/access",
    component: PreviewAccessComponent,
  },
  {
    path: "preview/:previewId/subscription",
    component: PreviewSubscriptionComponent,
  },
  {
    path: "preview/:previewId/subscription/checkout",
    component: PreviewStripeCheckoutComponent,
  },
  {
    path: "file-detail/:id",
    component: FileDetailComponent,
  },
  {
    path: "overview",
    component: DigitalLayoutComponent,
    children: [
      {
        path: "",
        component: ShipGalleryComponent,
      },
      {
        matcher: shipMatcher,
        loadChildren: "./modules/digital-memory-log/digital-memory-log.module#DigitalMemoryLogModule",
      },
       {
        path: "user",
        loadChildren: "./modules/user/user.module#UserModule",
      },
    ],
    canActivate: [CamerallaAuthGuardService],
  },
 
 
  {
    path: "**",
    component: ErrorPageComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      { scrollPositionRestoration: "enabled" }
      // {preloadingStrategy: PreloadAllModules}
    ),
  ],
  exports: [RouterModule],
  providers: [CamerallaAuthGuardService, PersmissionGuardService],
})
export class AppRoutingModule {}
